import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { useUserStore } from '@lib/store';
import { PaletteUtils } from '@shared/utils';

interface UserInfoProps {
  className?: string;
}

export const UserInfo = (props: UserInfoProps) => {
  const userStore = useUserStore();

  const { t, i18n } = useTranslation();

  const lastLogin = userStore.data?.lastLogin === '0001-01-01T01:00:00+01:00' ? null : userStore.data?.lastLogin;
  const lastLoginText = lastLogin
    ? dayjs(lastLogin)
        .locale(i18n.language || 'en')
        .format(`ddd, DD.MM.YY [${t('header.userInfo.date.at')}] hh:mm A`)
    : t('header.userInfo.date.none');
  return (
    <div
      className={clsx(
        'inline-block text-xs font-semibold leading-[1.58] tracking-[0.1px]',
        'text-[#8c8c8d] text-left uppercase align-middle select-text',
        'mr-[66px] max-[840px]:pl-5',

        'max-[840px]:mr-0 max-[840px]:mt-2.5 max-[840px]:order-3',
        props.className,
      )}
    >
      <div className='max-[840px]:flex'>
        <span>{t('header.userInfo.fields.loggedAs')}: </span>
        <span
          className={clsx(
            'select-initial max-[840px]:ml-1',
            PaletteUtils.isBordierPalette ? 'text-[#4c3c2c] max-[840px]:text-[#4c3c2c]' : 'text-[#dadada]',
          )}
        >
          {userStore.data?.name || ''}
        </span>
      </div>
      <div>
        <span>{t('header.userInfo.fields.lastLogin')}: </span>
        <span
          className={clsx(
            'select-text max-[840px]:ml-1',
            PaletteUtils.isBordierPalette ? 'text-[#4c3c2c] max-[840px]:text-[#4c3c2c]' : 'text-[#dadada]',
          )}
        >
          {lastLoginText}
        </span>
      </div>
    </div>
  );
};
